import { PlanHandleComponent } from "../components";
import { connect } from "react-redux";
import { GetDataPlanHandlePlanHandleAction, SetDataPlanHandlePlanHandleAction } from "../actions";
import { GetFilterReportHandleAction, ClearDataFilterReportHandleAction} from "../actions";
import { GetDataTableReportHandleAction } from "../actions";
import { GetDataHeaderTableReportHandleAction } from "../actions";

const mapStateToProps = state => {
    return {
        ...state,
        DataPlanHandle: state.allPlanHandleReducers.planHandleReducer.DataPlanHandle,
        isResult: state.allPlanHandleReducers.isResultReducer.isResult,
        DataFilterReport: state.allPlanHandleReducers.filterReportReducer.DataFilterReport,
        DataTableReport: state.allPlanHandleReducers.tableReportReducer.DataTableReport,
        DataHeaderTableReport: state.allPlanHandleReducers.headerTableReportReducer.DataHeaderTableReport,
        DataLayout: state.allLayoutReducers.layoutALLReducer.layoutReducer.DataLayout,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetDataPlanHandle: (DataPlanHandle) => {
            dispatch(GetDataPlanHandlePlanHandleAction(DataPlanHandle));
        },
        SetDataPlanHandle: (DataPlanHandle) => {
            dispatch(SetDataPlanHandlePlanHandleAction(DataPlanHandle));
        },
        GetDataFilterReport: (ID) => {
            dispatch(GetFilterReportHandleAction(ID));
        },
        ClearDataFilterReport: () => {
            dispatch(ClearDataFilterReportHandleAction());
        },
        GetDataTableReport: (ID, DataTables) => {
            dispatch(GetDataTableReportHandleAction(ID, DataTables))
        },
        GetDataHeaderTableReport: (ID) => {
            dispatch(GetDataHeaderTableReportHandleAction(ID));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlanHandleComponent);